

export namespace Logger {
    export function info(...data: any[]) {
        console.info(...data)
    }
}

